<div class="container_filter">
  <div class="header">
    <div class="title-description">
      <h2 class="filter-title">
        {{ "inventory.filter.title" | translate }}
      </h2>
      <p class="filter-description">
        {{ "filter.description" | translate }}
      </p>
    </div>
    <button class="close" (click)="close()">
      <img src="assets/icones/close.svg" alt="" />
    </button>
  </div>

  <div class="content">
    <div class="selection">
      <div class="import-and-selected">
        <ng-container *ngIf="inventoryFilters?.filters?.length > 0">
          <button class="select-saved-filter" [matMenuTriggerFor]="menu">
            <img src="assets/icones/import-filter.svg" alt="" />
            <small>{{ "filter.import" | translate }}</small>
          </button>
          <mat-menu #menu="matMenu" class="import-menu" >
            <div class="filter_btn"
              *ngFor="let filter of inventoryFilters?.filters || []"
              
            >
              <span (click)="setFilter(filter)"
              >{{ filter.name }}</span>
              <button (click)="deleteFilter(filter)" >
                <img src="assets/icones/delete_btn.svg" alt="">
              </button>
            </div>
          </mat-menu>
        </ng-container>
        <div class="applied-filters-count" (click)="clearFilters()">
          <span class="count">{{ getFiltersCount() }}</span>
          <span>{{ "filter.applied" | translate }}</span>
          <img src="assets/icones/clear-filter.svg" alt="" />
        </div>
      </div>
      <div
        class="filter-group"
        [class.filter-group-selected]="selectedGroup === 'product_info'"
        (click)="selectedGroup = 'product_info'"
      >
        <div class="group-title">
          <img src="assets/icones/info.svg" alt="" />
          <h3>{{ "inventory.filter.groups.product_info" | translate }}</h3>
        </div>
        <div class="filters">
          <div class="filter" *ngIf="filter.productsInfoFilter.name">
            <span>
              {{ "inventory.filter.fields.name" | translate }} :
              {{ filter.productsInfoFilter.name }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.productsInfoFilter.name = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.productsInfoFilter.sku">
            <span>
              {{ "inventory.filter.fields.sku" | translate }} :
              {{ filter.productsInfoFilter.sku }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.productsInfoFilter.sku = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.productsInfoFilter.barcode != null">
            <span>
              {{ "inventory.filter.fields.barcode" | translate }} :
              {{ filter.productsInfoFilter.barcode }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.productsInfoFilter.barcode = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.productsInfoFilter.brands.length > 0">
            <span>
              {{ "inventory.filter.fields.brands" | translate }} :
              {{ getBrandsNames() }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.productsInfoFilter.brands = []
              "
            />
          </div>
          <div class="filter" *ngIf="filter.productsInfoFilter.status">
            <span>
              {{ "inventory.filter.fields.status" | translate }} :
              {{
                "inventory.filter.values." + filter.productsInfoFilter.status
                  | translate
              }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.productsInfoFilter.status = undefined
              "
            />
          </div>
          <div
            class="filter"
            *ngIf="filter.productsInfoFilter.has_variants !== undefined"
          >
            <span>
              {{ "inventory.filter.fields.product_type" | translate }} :
              {{
                (filter.productsInfoFilter.has_variants === true
                  ? "inventory.filter.values.with_variants"
                  : "inventory.filter.values.without_variants"
                ) | translate
              }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.productsInfoFilter.has_variants = undefined
              "
            />
          </div>
        </div>
      </div>
      <div
        class="filter-group"
        [class.filter-group-selected]="selectedGroup === 'inventory'"
        (click)="selectedGroup = 'inventory'"
      >
        <div class="group-title">
          <img src="assets/icones/inventory.svg" alt="" />
          <h3>{{ "inventory.filter.groups.inventory" | translate }}</h3>
        </div>
        <div class="filters">
          <div
            class="filter"
            *ngIf="
              filter.inventoryFilter.sales_price_min != null ||
              filter.inventoryFilter.sales_price_max != null
            "
          >
            <span>
              {{ "inventory.filter.fields.retailer_price" | translate }} :
              <ng-container *ngIf="filter.inventoryFilter.sales_price_min != null">
                {{ "common.from" | translate }}
                {{ filter.inventoryFilter.sales_price_min }} €
              </ng-container>
              <ng-container *ngIf="filter.inventoryFilter.sales_price_max != null">
                {{ "common.to" | translate }}
                {{ filter.inventoryFilter.sales_price_max }} €
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.inventoryFilter.sales_price_min = undefined;
                filter.inventoryFilter.sales_price_max = undefined
              "
            />
          </div>
          <div
            class="filter"
            *ngIf="
              filter.inventoryFilter.cost_min != null || filter.inventoryFilter.cost_max != null
            "
          >
            <span>
              {{ "inventory.filter.fields.cost" | translate }} :
              <ng-container *ngIf="filter.inventoryFilter.cost_min != null">
                {{ "common.from" | translate }}
                {{ filter.inventoryFilter.cost_min }} €
              </ng-container>
              <ng-container *ngIf="filter.inventoryFilter.cost_max != null">
                {{ "common.to" | translate }}
                {{ filter.inventoryFilter.cost_max }} €
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.inventoryFilter.cost_min = undefined;
                filter.inventoryFilter.cost_max = undefined
              "
            />
          </div>
          <div
            class="filter"
            *ngIf="
              filter.inventoryFilter.quantity_min != null ||
              filter.inventoryFilter.quantity_max != null
            "
          >
            <span>
              {{ "inventory.filter.fields.quantity" | translate }} :
              <ng-container *ngIf="filter.inventoryFilter.quantity_min != null">
                {{ "common.from" | translate }}
                {{ filter.inventoryFilter.quantity_min }}
              </ng-container>
              <ng-container *ngIf="filter.inventoryFilter.quantity_max != null">
                {{ "common.to" | translate }}
                {{ filter.inventoryFilter.quantity_max }}
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.inventoryFilter.quantity_min = undefined;
                filter.inventoryFilter.quantity_max = undefined
              "
            />
          </div>
          <div
            class="filter"
            *ngIf="
              filter.inventoryFilter.reorder_point_min != null ||
              filter.inventoryFilter.reorder_point_max != null
            "
          >
            <span>
              {{ "inventory.filter.fields.reorder_point" | translate }} :
              <ng-container *ngIf="filter.inventoryFilter.reorder_point_min != null">
                {{ "common.from" | translate }}
                {{ filter.inventoryFilter.reorder_point_min }}
              </ng-container>
              <ng-container *ngIf="filter.inventoryFilter.reorder_point_max != null">
                {{ "common.to" | translate }}
                {{ filter.inventoryFilter.reorder_point_max }}
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.inventoryFilter.reorder_point_min = undefined;
                filter.inventoryFilter.reorder_point_max = undefined
              "
            />
          </div>
          <div
            class="filter"
            *ngIf="
              filter.inventoryFilter.expiry_date_min ||
              filter.inventoryFilter.expiry_date_max
            "
          >
            <span>
              {{ "inventory.filter.fields.expiry_date" | translate }} :
              <ng-container *ngIf="filter.inventoryFilter.expiry_date_min">
                {{ "common.from" | translate }}
                {{ filter.inventoryFilter.expiry_date_min }}
              </ng-container>
              <ng-container *ngIf="filter.inventoryFilter.expiry_date_max">
                {{ "common.to" | translate }}
                {{ filter.inventoryFilter.expiry_date_max }}
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.inventoryFilter.expiry_date_min = undefined;
                filter.inventoryFilter.expiry_date_max = undefined
              "
            />
          </div>
        </div>
      </div>
      <div
        class="filter-group"
        [class.filter-group-selected]="selectedGroup === 'organize'"
        (click)="selectedGroup = 'organize'"
      >
        <div class="group-title">
          <img src="assets/icones/organize.svg" alt="" />
          <h3>{{ "inventory.filter.groups.organize" | translate }}</h3>
        </div>
        <div class="filters">
          <div class="filter" *ngIf="filter.organizeFilter.categories.length > 0">
            <span>
              {{ "inventory.filter.fields.categories" | translate }} :
              {{ getCategoriesNames() }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.organizeFilter.categories = []
              "
            />
          </div>
          <div class="filter" *ngIf="filter.organizeFilter.tags.length > 0">
            <span>
              {{ "inventory.filter.fields.tags" | translate }} :
              {{ getTagsNames() }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.organizeFilter.tags = []
              "
            />
          </div>
          <div
            class="filter"
            *ngIf="filter.organizeFilter.has_catalogs !== undefined"
          >
            <span>
              {{ "inventory.filter.fields.included_in_catalogs" | translate }} :
              {{
                (filter.organizeFilter.has_catalogs
                  ? "inventory.filter.values.yes"
                  : "inventory.filter.values.no")
                | translate
              }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.organizeFilter.has_catalogs = undefined
              "
            />
          </div>
          <div class="filter" *ngIf="filter.organizeFilter.number_of_catalogs != null">
            <span>
              {{ "inventory.filter.fields.number_of_catalogs" | translate }} :
              {{ filter.organizeFilter.number_of_catalogs }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                $event.stopPropagation();
                filter.organizeFilter.number_of_catalogs = undefined
              "
            />
          </div>
        </div>
      </div>
    </div>
    <div class="form">
      <ng-container *ngIf="selectedGroup === 'product_info'">
        <div class="form-title">
          <img src="assets/icones/info.svg" alt="" />
          <h3>{{ "inventory.filter.groups." + selectedGroup | translate }}</h3>
        </div>

        <div class="inputs">
          <div class="field">
            <label for="name">{{
              "inventory.filter.fields.name" | translate
            }}</label>
            <input
              id="name"
              type="text"
              [(ngModel)]="filter.productsInfoFilter.name"
              [placeholder]="'inventory.filter.fields.name' | translate"
            />
          </div>
          <div class="field">
            <label for="sku">{{
              "inventory.filter.fields.sku" | translate
            }}</label>
            <input
              id="sku"
              type="text"
              [(ngModel)]="filter.productsInfoFilter.sku"
              [placeholder]="'inventory.filter.fields.sku' | translate"
            />
          </div>
          <div class="field">
            <label for="barcode">{{
              "inventory.filter.fields.barcode" | translate
            }}</label>
            <input
              id="barcode"
              type="number"
              [(ngModel)]="filter.productsInfoFilter.barcode"
              [placeholder]="'inventory.filter.fields.barcode' | translate"
            />
          </div>
          <div class="field equality_field">
            <label for="">{{
              "inventory.filter.fields.brands" | translate
            }}</label>
            <mat-chip-list #brandsChipList>
              <mat-chip
                *ngFor="let brand of filter.productsInfoFilter.brands; index as i"
                (removed)="filter.productsInfoFilter.brands.splice(i, 1)"
              >
                {{ brand.name }}
                <button matChipRemove>
                  <mat-icon style="color: #868e96">cancel</mat-icon>
                </button>
              </mat-chip>
              <input
                class="input_chip"
                [placeholder]="'inventory.filter.fields.brands' | translate"
                #fruitInput
                (input)="filterBrands()"
                [(ngModel)]="brandsFilterKey"
                [ngModelOptions]="{ standalone: true }"
                [matAutocomplete]="brandsAutoComplete"
                [matChipInputFor]="brandsChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              />
            </mat-chip-list>
            <mat-autocomplete
              (opened)="onBrandsAutocompleteOpened()"
              (closed)="onBrandsAutocompleteClosed()"
              (optionSelected)="selectOption('brand', $event)"
              #brandsAutoComplete="matAutocomplete"
            >
              <ng-container *ngIf="filteredBrands$ | async as brands">
                <mat-option
                  *ngFor="let brand of brands"
                  [value]="brand"
                >
                  {{ brand.name }}
                </mat-option>
              </ng-container>
            </mat-autocomplete>
          </div>
          <div class="field" *ngIf="!data || !data.isQuoteProducts">
            <label for="">{{
              "inventory.filter.fields.status" | translate
            }}</label>
            <select [(ngModel)]="filter.productsInfoFilter.status">
              <option value="" disabled selected>
                {{ "inventory.filter.fields.status" | translate }}
              </option>
              <option value="Published">
                {{ "inventory.filter.values.Published" | translate }}
              </option>
              <option value="Draft">
                {{ "inventory.filter.values.Draft" | translate }}
              </option>
            </select>
          </div>
          <div class="field" *ngIf="!data || !data.isQuoteProducts">
            <label for="">
              {{ "inventory.filter.fields.product_type" | translate }}
            </label>
            <select [(ngModel)]="filter.productsInfoFilter.has_variants">
              <option value="" disabled selected>
                {{ "inventory.filter.fields.product_type" | translate }}
              </option>
              <option [value]="true">
                {{ "inventory.filter.values.with_variants" | translate }}
              </option>
              <option [value]="false">
                {{ "inventory.filter.values.without_variants" | translate }}
              </option>
            </select>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="selectedGroup === 'inventory'">
        <div class="form-title">
          <img src="assets/icones/inventory.svg" alt="" />
          <h3>{{ "inventory.filter.groups." + selectedGroup | translate }}</h3>
        </div>

        <div class="inputs">
          <div class="inputs-pair">
            <div class="field">
              <label for="sales_price_min">{{
                "inventory.filter.fields.sales_price_min" | translate
              }}</label>
              <input
                id="sales_price_min"
                type="number"
                min="0"
                [max]="filter.inventoryFilter.sales_price_max || 1"
                [(ngModel)]="filter.inventoryFilter.sales_price_min"
                [placeholder]="
                  'inventory.filter.fields.sales_price_min' | translate
                "
              />
            </div>
            <div class="field">
              <label for="sales_price_max">{{
                "inventory.filter.fields.sales_price_max" | translate
              }}</label>
              <input
                id="sales_price_max"
                type="number"
                [min]="filter.inventoryFilter.sales_price_min || 0"
                [(ngModel)]="filter.inventoryFilter.sales_price_max"
                [placeholder]="
                  'inventory.filter.fields.sales_price_max' | translate
                "
              />
            </div>
          </div>
          <div class="inputs-pair" *ngIf="!data || !data.isQuoteProducts">
            <div class="field">
              <label for="cost_min">{{
                "inventory.filter.fields.cost_min" | translate
              }}</label>
              <input
                id="cost_min"
                type="number"
                min="0"
                [max]="filter.inventoryFilter.cost_max || 1"
                [(ngModel)]="filter.inventoryFilter.cost_min"
                [placeholder]="'inventory.filter.fields.cost_min' | translate"
              />
            </div>
            <div class="field">
              <label for="cost_max">{{
                "inventory.filter.fields.cost_max" | translate
              }}</label>
              <input
                id="cost_max"
                type="number"
                [min]="filter.inventoryFilter.cost_min || 0"
                [(ngModel)]="filter.inventoryFilter.cost_max"
                [placeholder]="'inventory.filter.fields.cost_max' | translate"
              />
            </div>
          </div>
          <div class="inputs-pair">
            <div class="field">
              <label for="quantity_min">{{
                "inventory.filter.fields.quantity_min" | translate
              }}</label>
              <input
                id="quantity_min"
                type="number"
                min="0"
                [max]="filter.inventoryFilter.quantity_max || 1"
                [(ngModel)]="filter.inventoryFilter.quantity_min"
                [placeholder]="'inventory.filter.fields.quantity_min' | translate"
              />
            </div>
            <div class="field">
              <label for="quantity_max">{{
                "inventory.filter.fields.quantity_max" | translate
              }}</label>
              <input
                id="quantity_max"
                type="number"
                [min]="filter.inventoryFilter.quantity_min || 0"
                [(ngModel)]="filter.inventoryFilter.quantity_max"
                [placeholder]="'inventory.filter.fields.quantity_max' | translate"
              />
            </div>
          </div>
          <div class="inputs-pair" *ngIf="!data || !data.isQuoteProducts">
            <div class="field">
              <label for="reorder_point_min">{{
                "inventory.filter.fields.reorder_point_min" | translate
              }}</label>
              <input
                id="reorder_point_min"
                type="number"
                min="0"
                [max]="filter.inventoryFilter.reorder_point_max || 1"
                [(ngModel)]="filter.inventoryFilter.reorder_point_min"
                [placeholder]="
                  'inventory.filter.fields.reorder_point_min' | translate
                "
              />
            </div>
            <div class="field">
              <label for="reorder_point_max">{{
                "inventory.filter.fields.reorder_point_max" | translate
              }}</label>
              <input
                id="reorder_point_max"
                type="number"
                [min]="filter.inventoryFilter.reorder_point_min || 0"
                [(ngModel)]="filter.inventoryFilter.reorder_point_max"
                [placeholder]="
                  'inventory.filter.fields.reorder_point_max' | translate
                "
              />
            </div>
          </div>
          <div class="inputs-pair" *ngIf="!data || !data.isQuoteProducts">
            <div class="field">
              <label for="expiry_date_min">{{
                "inventory.filter.fields.expiry_date_min" | translate
              }}</label>
              <input
                id="expiry_date_min"
                type="date"
                [(ngModel)]="filter.inventoryFilter.expiry_date_min"
                [placeholder]="
                  'inventory.filter.fields.expiry_date_min' | translate
                "
              />
            </div>
            <div class="field">
              <label for="expiry_date_max">{{
                "inventory.filter.fields.expiry_date_max" | translate
              }}</label>
              <input
                id="expiry_date_max"
                type="date"
                [(ngModel)]="filter.inventoryFilter.expiry_date_max"
                [placeholder]="
                  'inventory.filter.fields.expiry_date_max' | translate
                "
              />
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="selectedGroup === 'organize'">
        <div class="form-title">
          <img src="assets/icones/organize.svg" alt="" />
          <h3>{{ "inventory.filter.groups." + selectedGroup | translate }}</h3>
        </div>
        <div class="inputs">
          <div class="field equality_field">
            <label for="">{{
              "inventory.filter.fields.categories" | translate
            }}</label>
            <mat-chip-list #categoriesChipList>
              <mat-chip
                *ngFor="
                  let category of filter.organizeFilter.categories;
                  index as i
                "
                (removed)="filter.organizeFilter.categories.splice(i, 1)"
              >
                {{ category.name }}
                <button matChipRemove>
                  <mat-icon style="color: #868e96">cancel</mat-icon>
                </button>
              </mat-chip>
              <input
                class="input_chip"
                [placeholder]="'inventory.filter.fields.categories' | translate"
                #fruitInput
                (input)="filterCategories()"
                [(ngModel)]="categoriesFilterKey"
                [ngModelOptions]="{ standalone: true }"
                [matAutocomplete]="categoriesAutoComplete"
                [matChipInputFor]="categoriesChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              />
            </mat-chip-list>
            <mat-autocomplete (optionSelected)="selectOption('category', $event)" #categoriesAutoComplete="matAutocomplete">
              <ng-container *ngIf="filteredCategories$ | async as categories">
                <mat-option
                  *ngFor="let category of categories"
                  [value]="category"
                >
                  {{ category.name }}
                </mat-option>
              </ng-container>
            </mat-autocomplete>
          </div>
          <div class="field equality_field">
            <label for="">{{ "inventory.filter.fields.tags" | translate }}</label>
            <mat-chip-list #tagsChipList>
              <mat-chip
                *ngFor="let tag of filter.organizeFilter.tags; index as i"
                (removed)="filter.organizeFilter.tags.splice(i, 1)"
              >
                {{ tag.name }}
                <button matChipRemove>
                  <mat-icon style="color: #868e96">cancel</mat-icon>
                </button>
              </mat-chip>
              <input
                class="input_chip"
                [placeholder]="'inventory.filter.fields.tags' | translate"
                #fruitInput
                (input)="filterTags()"
                [(ngModel)]="tagsFilterKey"
                [ngModelOptions]="{ standalone: true }"
                [matAutocomplete]="tagsAutoComplete"
                [matChipInputFor]="tagsChipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              />
            </mat-chip-list>
            <mat-autocomplete (optionSelected)="selectOption('tag', $event)" #tagsAutoComplete="matAutocomplete">
              <ng-container *ngIf="filteredTags$ | async as tags">
                <mat-option
                  *ngFor="let tag of tags"
                  [value]="tag"
                >
                  {{ tag.name }}
                </mat-option>
              </ng-container>
            </mat-autocomplete>
          </div>
          <div class="inputs-pair" *ngIf="!data || !data.isQuoteProducts">
            <div class="field">
              <label for="">{{
                "inventory.filter.fields.included_in_catalogs" | translate
              }}</label>
              <select [(ngModel)]="filter.organizeFilter.has_catalogs">
                <option [ngValue]="undefined" disabled>
                  {{ "inventory.filter.fields.included_in_catalogs" | translate }}
                </option>
                <option [ngValue]="true">
                  {{ "inventory.filter.values.yes" | translate }}
                </option>
                <option [ngValue]="false">
                  {{ "inventory.filter.values.no" | translate }}
                </option>
              </select>
            </div>
            <div class="field">
              <label for="number_of_catalogs">{{
                "inventory.filter.fields.number_of_catalogs" | translate
              }}</label>
              <input
                id="number_of_catalogs"
                type="number"
                [(ngModel)]="filter.organizeFilter.number_of_catalogs"
                [placeholder]="
                  'inventory.filter.fields.number_of_catalogs' | translate
                "
              />
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="footer submet_btns">
    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
        <span>{{"common.cancel"|translate | uppercase}}</span>
        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
    </button>
    <div class="save-apply">
      <div class="save-filter-form" *ngIf="toggleSaveFilterForm && getFiltersCount() > 0">
        <div class="label-action">
          <label for="filter_name">{{
            "filter.filter_name" | translate
          }}</label>
          <div class="actions">
            <button class="cancel-btn" (click)="toggleSaveFilter()">{{ "common.cancel" | translate }}</button>
            <button class="save-btn" (click)="save()">
              {{ "common.save" | translate | uppercase }}
            </button>
          </div>
        </div>
        <input
          id="filter_name"
          type="text"
          class="filter-name-input"
          [placeholder]="'filter.filter_name' | translate"
          [(ngModel)]="filterName"
          [formControl]="filterNameControl"
        />
        <span class="error_ms" *ngIf="filterNameControl?.touched && filterNameControl?.errors">
          {{ "common.required_field" | translate }}
        </span>
      </div>
      <button
        class="save save_filter"
        [disabled]="getFiltersCount() <= 0" *ngIf="!toggleSaveFilterForm && !data"
        (click)="toggleSaveFilter()"
      >
        <img src="assets/icones/save-filter.svg" alt="" />
        <small>{{ "filter.save" | translate }}</small>
      </button>
      <button class="save_btn_pop_up blue_btn" (click)="apply()">
        <small>{{ "filter.apply" | translate | uppercase }}</small>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </div>
  </div>
</div>
